import { HTMLAttributes, PropsWithChildren } from 'react';
import { PropsWithTestId } from '../../../../../types';
import cn from 'classnames';
import styles from './ResetFilterButton.module.scss';

export interface ResetFilterButtonProps
  extends PropsWithTestId<PropsWithChildren<HTMLAttributes<HTMLSpanElement>>> {
  disabled?: boolean;
  iconName?: string;
}

export function ResetFilterButton(props: ResetFilterButtonProps) {
  const { disabled, iconName, className, children, testId, ...restProps } =
    props;

  const wrapperClassName = cn(styles.button, className, {
    [styles.disabled]: disabled,
  });

  return (
    <span {...restProps} className={wrapperClassName} data-testid={testId}>
      <span className={styles.text}>{children}</span>
      {iconName && (
        <span
          className={cn('material-icons', styles.icon)}
          data-testid="reset-filter-icon"
        >
          {iconName}
        </span>
      )}
    </span>
  );
}

ResetFilterButton.defaultProps = {
  testId: 'reset-filter-button-action',
};
